import {Component, input} from '@angular/core';
import {EvaluationCriteria} from '@frontend/directus';
import {
  ProgressDashboardGenericTableComponent,
  TableConfig,
} from '../progress-dashboard-generic-table.component';
import {SubCriteriaAttributeItem} from '../../../subcriteria-attribute-evaluation/subcriteria-attribute-evaluation.types';

export const EC_TABLE_CONFIG: TableConfig<EvaluationCriteria> = {
  getNumberFromAttribute: (attribute) => attribute.ecNumber,
  findCriteriaByNumber: (criteria, number) => criteria.find((ec) => ec.ecNumber === number),
  getTranslations: (criteria) => criteria.translations,
  getSubCriteriaNumber: (attribute) => attribute.scNumber,
  sortAscending: true,
};

@Component({
  selector: 'app-progress-dashboard-rfp-table',
  imports: [ProgressDashboardGenericTableComponent],
  template: `
    <app-progress-dashboard-generic-table
      [label]="label()"
      [subCriteriaAttributes]="subCriteriaAttributes()"
      [criteria]="evaluationCriteria()"
      [config]="tableConfig"
    />
  `,
})
export class ProgressDashboardRfpTableComponent {
  readonly label = input.required<string>();
  readonly subCriteriaAttributes = input.required<SubCriteriaAttributeItem[]>();
  readonly evaluationCriteria = input.required<EvaluationCriteria[]>();

  protected readonly tableConfig = EC_TABLE_CONFIG;
}
